export default __webpack_public_path__ + "static/media/851.1a07b8ca.gif";